"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDateTimeFormat = exports.getPopupRenderPosition = exports.convertTagsToQuery = exports.updateFilters = exports.resetTags = exports.addTag = exports.removeTagByIndex = exports.getRequiredTagsForReset = exports.getRequiredInitialTags = exports.getNewItem = exports.getDefaultValuesByType = exports.getTagValues = exports.mergeObjects = void 0;

var _findIndex = _interopRequireDefault(require("lodash/findIndex"));

var _sbStructuredFilterConstants = require("./sb-structured-filter-constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ENUM = _sbStructuredFilterConstants.filterTypes.ENUM,
    DATE = _sbStructuredFilterConstants.filterTypes.DATE,
    RANGE = _sbStructuredFilterConstants.filterTypes.RANGE,
    TEXT = _sbStructuredFilterConstants.filterTypes.TEXT,
    FULL_TEXT = _sbStructuredFilterConstants.filterTypes.FULL_TEXT;
var AND = _sbStructuredFilterConstants.filterOperators.AND,
    OR = _sbStructuredFilterConstants.filterOperators.OR;
var FULL = _sbStructuredFilterConstants.axleInformationTypes.FULL;
/**
 * Merge to objects.
 * @param obj1
 * @param obj2
 * @returns {Object}
 */

var mergeObjects = function mergeObjects(obj1, obj2) {
  return _objectSpread(_objectSpread({}, obj1), obj2);
};
/**
 * Return the value shown in tags for each enum type.
 * @param tag
 * @returns {String}
 */


exports.mergeObjects = mergeObjects;

var getTagValues = function getTagValues(tag) {
  var _tag$item = tag.item,
      type = _tag$item.type,
      options = _tag$item.options,
      suffix = _tag$item.suffix,
      values = tag.values;

  switch (type) {
    case ENUM:
      {
        var selectedOptionIndex = (0, _findIndex.default)(options, function (option) {
          return option.value.toString() === values.toString();
        });
        return selectedOptionIndex !== -1 ? options[selectedOptionIndex].label : values;
      }

    case RANGE:
      return "(".concat(values.from).concat(suffix || '', " - ").concat(values.to).concat(suffix || '', ")");

    case TEXT:
      return "\"".concat(values, "\"");

    case FULL_TEXT:
      return "\"".concat(values, "\"");

    case DATE:
      {
        return "(".concat(values.fromText, " - ").concat(values.toText, ")");
      }

    default:
      return values;
  }
};
/**
 * Return the default values for every enum value type.
 * @param type
 * @param dateProps
 * @returns {*}
 */


exports.getTagValues = getTagValues;

var getDefaultValuesByType = function getDefaultValuesByType(_ref) {
  var type = _ref.type,
      dateProps = _ref.dateProps;

  var _filterDefaults = (0, _sbStructuredFilterConstants.filterDefaults)(dateProps),
      DEFAULT_ENUM = _filterDefaults.ENUM,
      DEFAULT_DATE = _filterDefaults.DATE,
      DEFAULT_RANGE = _filterDefaults.RANGE,
      DEFAULT_TEXT = _filterDefaults.TEXT,
      DEFAULT_FULL_TEXT = _filterDefaults.FULL_TEXT;

  switch (type) {
    case ENUM:
      return DEFAULT_ENUM;

    case RANGE:
      return DEFAULT_RANGE;

    case TEXT:
      return DEFAULT_TEXT;

    case FULL_TEXT:
      return DEFAULT_FULL_TEXT;

    case DATE:
      return DEFAULT_DATE;

    default:
      return null;
  }
};
/**
 * Return a new item object.
 * @param item
 * @param activeOperator
 * @param dateProps
 * @returns {Object}
 */


exports.getDefaultValuesByType = getDefaultValuesByType;

var getNewItem = function getNewItem(_ref2) {
  var item = _ref2.item,
      _ref2$activeOperator = _ref2.activeOperator,
      activeOperator = _ref2$activeOperator === void 0 ? null : _ref2$activeOperator,
      dateProps = _ref2.dateProps;

  if (!item) {
    return null;
  }

  return {
    item: item,
    values: item.defaultValue || getDefaultValuesByType({
      type: item.type,
      dateProps: dateProps
    }),
    negated: false,
    partialMatch: false,
    operator: activeOperator || AND
  };
};
/**
 * Return a list of tags which are required, but first check if they are not already in initialTags.
 * @param initialTags
 * @param filters
 * @param dateProps
 * @returns {Array}
 */


exports.getNewItem = getNewItem;

var getRequiredInitialTags = function getRequiredInitialTags(_ref3) {
  var initialTags = _ref3.initialTags,
      filters = _ref3.filters,
      dateProps = _ref3.dateProps;
  return filters.reduce(function (newTags, filter) {
    var required = filter.required;

    if (required) {
      var tagExists = (0, _findIndex.default)(initialTags, function (tag) {
        return tag.item.attribute === filter.attribute && tag.item.required;
      });

      if (tagExists === -1) {
        // doesn't exist, add it!
        newTags.push(getNewItem({
          item: filter,
          activeOperator: AND,
          dateProps: dateProps
        }));
      }
    }

    return newTags;
  }, []);
};
/**
 * Return a list of tags which are required, for the reset filters.
 * @param filters
 * @param dateProps
 * @returns {Array}
 */


exports.getRequiredInitialTags = getRequiredInitialTags;

var getRequiredTagsForReset = function getRequiredTagsForReset(_ref4) {
  var filters = _ref4.filters,
      dateProps = _ref4.dateProps;
  return filters.reduce(function (newTags, filter) {
    var required = filter.required;

    if (required) {
      newTags.push(getNewItem({
        item: filter,
        activeOperator: AND,
        dateProps: dateProps
      }));
    }

    return newTags;
  }, []);
};
/**
 * Return a new object of tags without the specific index.
 * @param tags
 * @param index
 * @returns {Object}
 */


exports.getRequiredTagsForReset = getRequiredTagsForReset;

var removeTagByIndex = function removeTagByIndex(tags, index) {
  return tags.filter(function (_, i) {
    return i !== index;
  });
};

exports.removeTagByIndex = removeTagByIndex;

var addTag = function addTag(tags, activeItem, index) {
  if (index !== null) {
    return tags.map(function (tag, i) {
      return i === index ? activeItem : tag;
    });
  } // we are storing the item cleared from the required prop, because only the one of each filters can be required


  var _activeItem$item = activeItem.item,
      required = _activeItem$item.required,
      clearedItem = _objectWithoutProperties(_activeItem$item, ["required"]);

  var clearedActiveItem = _objectSpread(_objectSpread({}, activeItem), {}, {
    item: clearedItem
  });

  return tags.concat(clearedActiveItem);
};
/**
 * Removed all tags except the required ones.
 * @param tags
 * @returns {Array}
 */


exports.addTag = addTag;

var resetTags = function resetTags(tags) {
  return tags.filter(function (tag) {
    return tag.item.required;
  });
};
/**
 * Filter filters for duplicates when there is other operator then OR.
 * @param filters
 * @param activeOperator
 * @param tags
 * @returns {Array}
 */


exports.resetTags = resetTags;

var updateFilters = function updateFilters(filters, activeOperator, tags) {
  if (activeOperator === OR) return filters;
  return filters.filter(function (filter) {
    return (0, _findIndex.default)(tags, function (tag) {
      return tag.item.attribute === filter.attribute && tag.operator === AND;
    }) === -1;
  });
};
/**
 * Convert the tags array into the query needed for the rest API.
 * @param tags
 * @param allowOR
 * @param from
 * @param size
 * @param orderBy
 * @param orderField
 * @param timeZone
 * @param type
 * @returns {{from: number, size: number, andQuery: Array, notQuery: Array, sort: {field: number, order: string}}}
 */


exports.updateFilters = updateFilters;

var convertTagsToQuery = function convertTagsToQuery(_ref5) {
  var _ref5$tags = _ref5.tags,
      tags = _ref5$tags === void 0 ? [] : _ref5$tags,
      _ref5$allowOR = _ref5.allowOR,
      allowOR = _ref5$allowOR === void 0 ? false : _ref5$allowOR,
      _ref5$from = _ref5.from,
      from = _ref5$from === void 0 ? 0 : _ref5$from,
      _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 200 : _ref5$size,
      _ref5$orderBy = _ref5.orderBy,
      orderBy = _ref5$orderBy === void 0 ? _sbStructuredFilterConstants.orderTypes.DESC : _ref5$orderBy,
      _ref5$orderField = _ref5.orderField,
      orderField = _ref5$orderField === void 0 ? 'ID' : _ref5$orderField,
      _ref5$type = _ref5.type,
      type = _ref5$type === void 0 ? FULL : _ref5$type;
  var queries = tags.reduce(function (query, tag) {
    var _values$fromIso, _values$toIso;

    var _tag$item2 = tag.item,
        attribute = _tag$item2.attribute,
        tagType = _tag$item2.type,
        negated = tag.negated,
        operator = tag.operator,
        partialMatch = tag.partialMatch,
        values = tag.values;
    var tempQuery = {};

    switch (tagType) {
      case RANGE:
        tempQuery = {
          range: _defineProperty({}, attribute, {
            gte: values.from,
            lte: values.to
          })
        };
        break;

      case DATE:
        tempQuery = {
          range: _defineProperty({}, attribute, {
            gte: (_values$fromIso = values.fromIso) !== null && _values$fromIso !== void 0 ? _values$fromIso : values.from.toISOString(),
            lte: (_values$toIso = values.toIso) !== null && _values$toIso !== void 0 ? _values$toIso : values.to.toISOString()
          })
        };
        break;

      case TEXT:
        if (!partialMatch) {
          tempQuery = {
            term: _defineProperty({}, attribute, values)
          };
        } else {
          tempQuery = {
            regexp: _defineProperty({}, attribute, ".*".concat(values, ".*"))
          };
        }

        break;

      case FULL_TEXT:
        if (!partialMatch) {
          tempQuery = {
            match: _defineProperty({}, attribute, values)
          };
        } else {
          tempQuery = {
            wildcard: _defineProperty({}, attribute, "*".concat(values, "*"))
          };
        }

        break;

      case ENUM:
        tempQuery = {
          term: _defineProperty({}, attribute, values)
        };
        break;

      default:
        tempQuery = {};
    }

    if (operator === AND) {
      if (negated) {
        query.notQuery.push(tempQuery);
      } else {
        query.andQuery.push(tempQuery);
      }
    } else if (operator === OR) {
      query.orQuery.push(tempQuery);
    }

    return query;
  }, {
    andQuery: [],
    notQuery: [],
    orQuery: []
  });
  var andQuery = queries.andQuery,
      notQuery = queries.notQuery,
      orQuery = queries.orQuery;
  var ors = allowOR ? {
    orQuery: orQuery
  } : {};
  return _objectSpread(_objectSpread({
    from: from,
    size: size,
    andQuery: andQuery,
    notQuery: notQuery
  }, ors), {}, {
    sort: {
      field: orderField,
      order: orderBy
    },
    type: type
  });
};
/**
 * Returns the values for measuring the popups position.
 * @param popup
 * @returns {{ popupWidth: number, popupOffsetLeft: number, filterWidth: number }}
 */


exports.convertTagsToQuery = convertTagsToQuery;

var getPopupRenderPosition = function getPopupRenderPosition(popup) {
  var popupWidth = popup.offsetWidth; // block width

  var popupOffsetLeft = popup.offsetParent.offsetLeft; // block position from left

  var filterWidth = popup.offsetParent.offsetParent.offsetWidth; // filter width

  return {
    popupWidth: popupWidth,
    popupOffsetLeft: popupOffsetLeft,
    filterWidth: filterWidth
  };
};

exports.getPopupRenderPosition = getPopupRenderPosition;

var getDateTimeFormat = function getDateTimeFormat(_ref6) {
  var _format$year, _format$month, _format$day, _format$hour, _format$minute, _ref7, _ref8;

  var format = _ref6.format,
      timeZone = _ref6.timeZone,
      locale = _ref6.locale;
  return _objectSpread(_objectSpread({}, format), {}, {
    year: (_format$year = format.year) !== null && _format$year !== void 0 ? _format$year : 'numeric',
    month: (_format$month = format.month) !== null && _format$month !== void 0 ? _format$month : 'numeric',
    day: (_format$day = format.day) !== null && _format$day !== void 0 ? _format$day : 'numeric',
    hour: (_format$hour = format.hour) !== null && _format$hour !== void 0 ? _format$hour : 'numeric',
    minute: (_format$minute = format.minute) !== null && _format$minute !== void 0 ? _format$minute : 'numeric',
    timeZone: (_ref7 = (_ref8 = timeZone !== null && timeZone !== void 0 ? timeZone : format.timeZone) !== null && _ref8 !== void 0 ? _ref8 : locale) !== null && _ref7 !== void 0 ? _ref7 : 'UTC'
  });
};

exports.getDateTimeFormat = getDateTimeFormat;
//# sourceMappingURL=sb-structured-filter-utils.js.map